var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40 3.788a16.587 16.587 0 0 1-4.713 1.272A8.116 8.116 0 0 0 38.9.591a16.6 16.6 0 0 1-5.217 1.961 8.254 8.254 0 0 0-5.99-2.551A8.118 8.118 0 0 0 19.7 9.918a23.421 23.421 0 0 1-16.915-8.44 8.013 8.013 0 0 0 2.538 10.786 8.27 8.27 0 0 1-3.715-1.012 8.114 8.114 0 0 0 6.582 8.024 8.352 8.352 0 0 1-3.707.138 8.2 8.2 0 0 0 7.667 5.61A16.688 16.688 0 0 1 0 28.371 23.5 23.5 0 0 0 12.58 32 23 23 0 0 0 35.9 7.97 16.566 16.566 0 0 0 40 3.788Z",
  fill: "#fff"
})));
export default SvgTwitter;